export const siteName = "Doula Plouay Lorient (56)"
export const siteUrl = "https://www.aucreuxdemaman.fr"

export const brandName = "Au creux de maman"
export const practitionerName = "Maïwenn Keraudran"
export const profession = "Doula \u2013 Accompagnante périnatale"
export const addressStreet = "19 rue Louis Le Moenic"
export const addressCity = "Inguiniel"
export const addressPostalCode = "56240"
export const fullAddress = "19 rue Louis Le Moenic, 56240 Inguiniel"
export const location = "Inguiniel (56240)"
export const serviceArea = "Je vous reçois dans mon espace, à Inguiniel, ou à domicile dans un rayon de 35 kilomètres."
export const travelFees = "Au-delà de 15km d'Inguiniel, des frais de déplacement de 0.40€/km s'appliquent."
export const contactEmail = "aucreuxdemaman@gmail.com"
export const contactPhone = "06 25 89 56 64"
export const instagramHandle = "@au_creux_de_maman"
export const instagramUrl = "https://www.instagram.com/au_creux_de_maman?stkn=cWRzNmVha2VrdzU="
export const calendlyUrl =
  "https://calendly.com/aucreuxdemaman?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAcGRvZgJleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA85MzY2MTk3NDMzOTI0NTkAAacKgH5bXGSF8ZjJcS3ugXA-Th2-xf7cW2WXyJdME0uivVMaukgWwJV-I4-lrw_aem_GJB33-FaYgOTSDQRhr9mng&utm_id=97760_v0_s00_e0_tv3"


export const images = {
  logo: "https://static.lumi.new/material/90/909aed30e8a7ee7137ad59f80e4d4406.png",
  hero: "https://static.lumi.new/c0/c0761b7758167e517998790d8b438b63.png",
  portrait: "https://static.lumi.new/material/d0/d0528283e7d412945335571d147154bf.jpg",
  yoga: "https://static.lumi.new/77/77568de8a6aed8e680a89ea34c65de54.png",
  massagePreconception: "https://static.lumi.new/51/51c28c4eddfb94e0feec8920e03baaba.png",
  mother: "https://static.lumi.new/78/78da8a8cf99b818da4b5a6e47bbcfc7a.png",
  kit: "https://static.lumi.new/c8/c8a863705bb70eb98986b3e59353b5c8.png",
  linen: "https://static.lumi.new/26/260e00d07cadfafe544b857264965b0d.png",
  salon: "https://static.lumi.new/15/151265729a6ef095bec5de57664b6415.png",
  aboutFamily: "https://static.lumi.new/material/4b/4bb375cc951dc98e186f0b7e9d35a7f2.jpg",
  aboutAtmosphere: "https://static.lumi.new/material/9a/9a62e61ebee9a0aae4df0c83f79cf916.jpg",
  massagePrenatal: "https://static.lumi.new/9d/9d48ba66977f78be0fe27db40cfbb847.png",
  massagePostnatal: "https://static.lumi.new/material/0b/0bdb66daeeb072ba3e46068879e0d8dd.png",
  massageBebe: "https://static.lumi.new/f3/f3dbc3f083989117e45642e591f61001.png",
  portageBebe: "https://static.lumi.new/45/45807b5019f9014cb2a23941817e1500.png",
  babyYoga: "https://static.lumi.new/03/038bc7ba81e57e43b8e40a920cdf2ea8.png",
  reflexologieBebe: "https://static.lumi.new/material/f7/f7a45b50120dccbd11240d2034d8fb43.jpg",
}

export const navLinks = [
  { to: "/", label: "Accueil" },
  { to: "/a-propos", label: "Qui suis-je ?" },
  { to: "/accompagnement-doula", label: "Accompagnement Doula" },
  { to: "/prestations-maman", label: "Prestations Maman" },
  { to: "/prestations-femme", label: "Prestations Femme" },
  { to: "/prestations-bebe", label: "Prestations Bébé" },
  { to: "/planning-ateliers", label: "Planning ateliers" },
  { to: "/carte-cadeau", label: "Carte Cadeau" },
  { to: "/contact", label: "Contact" },
]

export const ateliersCollectifsMax = "Groupe de 6 personnes maximum."

export type AtelierPlanning = {
  id: string
  jour: string
  date: string
  horaire: string
  title: string
  anchorPath?: string
  anchorId?: string
  image: string
  description: string
  infos: string[]
  prix?: string
}

export const planningAteliers: AtelierPlanning[] = [
  {
    id: "collectif-massage-bebe",
    jour: "Samedi",
    date: "7 novembre 2026",
    horaire: "10h – 11h",
    title: "Atelier collectif massage bébé",
    anchorPath: "/prestations-bebe",
    anchorId: "atelier-massage-bebe",
    image: images.massageBebe,
    description:
      "Un atelier collectif pour apprendre les gestes du massage bébé, dans un cadre doux et chaleureux, et partager un moment de détente avec votre bébé.",
    infos: [
      "20 € pour 1 parent, 35 € à deux",
      "Prévoir une serviette et une huile végétale",
    ],
    prix: "20 €",
  },
  {
    id: "collectif-allaitement",
    jour: "Samedi",
    date: "21 novembre 2026",
    horaire: "10h – 11h",
    title: "Atelier collectif allaitement",
    image: images.mother,
    description:
      "Un temps d'échange autour de l'allaitement : préparer sereinement votre projet, poser vos questions et repartir avec des repères concrets.",
    infos: [
      "20 € pour 1 ou 2 parents",
      "Fortement conseillé durant la grossesse",
      "La présence du co-parent est encouragée",
    ],
    prix: "20 €",
  },
  {
    id: "collectif-portage-bebe",
    jour: "Samedi",
    date: "19 décembre 2026",
    horaire: "10h – 11h30",
    title: "Atelier collectif portage bébé",
    anchorPath: "/prestations-bebe",
    anchorId: "atelier-portage",
    image: images.portageBebe,
    description:
      "Découvrir les bienfaits du portage, les différentes solutions existantes et les règles essentielles pour porter bébé en toute sécurité, avec un temps de pratique et d'échange.",
    infos: [
      "20 € parent seul ou 35 € à deux",
      "Réalisable durant la grossesse ou avec bébé",
    ],
    prix: "20 € seul · 35 € à deux",
  },
]

export const prestations = [
  {
    id: "doula",
    title: "Accompagnement Doula",
    kicker: "Grossesse · Naissance · Post-partum",
    image: images.yoga,
    summary: "Un espace pour vous, pour déposer vos émotions, vos doutes, vos joies. Un soutien émotionnel et pratique tout au long de votre chemin vers la parentalité.",
    details: [
      "Écoute bienveillante",
      "Informations sur la physiologie de l'accouchement et l'allaitement",
      "Aide à la rédaction du projet de naissance",
      "Soutien logistique et organisationnel en amont, pendant et après la grossesse",
    ],
    pricing: [
      { label: "Séance en visio (1h30)", price: "50 €" },
      { label: "Séance sur place ou à domicile (1h30)", price: "60 €" },
      { label: "“Le temps de nous” – séance couple (1h30)", price: "60 €" },
      { label: "Formule 3 séances (1h30)", price: "170 €" },
      { label: "Formule 5 séances (1h30)", price: "290 €" },
      { label: "Formule Post-partum – 3 séances (2h30)", price: "260 €" },
      {
        label: "Formule Naissance (2 séances prénatales + 2 séances post-partum + dispo WhatsApp dès 37 SA + présence accouchement)",
        price: "380 €",
      },
    ],
  },
  {
    id: "massage-pre-conception",
    title: "Massage Pré-conception",
    kicker: "Avant · Fertilité & Reconnexion",
    image: images.massagePreconception,
    summary: "Massage complet pour préparer son corps et son esprit à accueillir la vie. Dans un premier temps, le massage permet de détendre les différentes couches musculaires et de drainer votre corps. Puis, j'utilise l'acupression en stimulant les méridiens spécifiques à la fertilité.\n\nCe soin s'adresse également aux femmes ayant vécu une IMG, IVG ou un arrêt naturel de grossesse ainsi qu'aux personnes atteintes d'adénomyose, d'endométriose, de fibrome, de SOPK, SPM et règles douloureuses.",
    details: [
      "Massage complet du corps, énergisant et rééquilibrant",
      "Utilisation de la vibration pour lever les blocages énergétiques et relancer l'énergie vitale",
      "Aide à relancer le cycle féminin et à retrouver un rythme plus fluide et harmonieux",
      "Soutien à la récupération physique et émotionnelle",
    ],
    note: "Soin bien-être, équilibrant, non médical, sans obligation de résultat.",
    pricing: [{ label: "Séance (1h15)", price: "70 €" }],
  },
  {
    id: "massage-bien-naitre",
    title: "Massage \"Bien-Naître\"",
    kicker: "Pendant · Massage prénatal",
    image: images.massagePrenatal,
    summary: "Un massage doux et enveloppant pour soulager les maux de la grossesse, relâcher les tensions physiques et émotionnelles, et s'offrir une parenthèse de douceur.",
    details: [
      "Soulage le dos, les lombaires et les jambes lourdes",
      "Favorise la détente et la connexion avec bébé",
    ],
    note: "Soin bien-être, équilibrant, non médical",
    pricing: [{ label: "Séance (1h15)", price: "70 €" }],
  },
  {
    id: "massage-postnatal",
    title: "Massage Post-natal + Resserrage de Bassin",
    kicker: "Après · Post-partum & Clôture",
    image: images.massagePostnatal,
    summary: "Après un petit temps d'échange, je vous propose un soin complet pour honorer votre corps dans sa maternité, vous recentrer, libérer les tensions accumulées. Le massage se clôture par un resserrage du bassin afin de le refermer physiquement et symboliquement.\n\nCe soin peut être réalisé dès l'accouchement (sauf césarienne : attendre 8 semaines), et ce sans limite de temps.",
    details: [
      "Massage du haut-du corps relaxant et réconfortant",
      "Utilisation de la vibration pour lever les blocages énergétiques et relancer l'énergie vitale",
      "Resserrage du bassin au tissu Rebozo",
      "Soutien à la récupération physique et émotionnelle",
      "Votre bébé peut vous accompagner durant le massage, je m'adapte à votre rythme",
    ],
    note: "Soin bien-être, équilibrant, non médical",
    pricing: [{ label: "Séance (1h30)", price: "80 €" }],
  },
]

export const formulesMaman = [
  {
    id: "formule-duo",
    title: "Formule Duo",
    subtitle: "2 prestations au choix",
    price: "130 €",
    image: images.massagePrenatal,
    description: "Choisissez 2 massages parmi pré-conception, bien-naître ou post-natal selon vos besoins.",
    savings: "Économie par rapport aux séances à l'unité",
  },
  {
    id: "formule-complete",
    title: "Formule Complète",
    subtitle: "3 prestations",
    price: "200 €",
    image: images.mother,
    description: "Un parcours bien-être complet : pré-conception, massage bien-naître et massage post-natal avec resserrage de bassin.",
    savings: "Accompagnement corporel global",
  },
]

export const prestationsFemme = [
  {
    id: "massage-douceurs-resonance",
    title: "Massage \"Douceurs et résonnance\"",
    kicker: "Massage Femme · Détente & Reconnexion",
    duration: "1h15",
    summary:
      "Après un petit temps d'échange, je vous propose un soin complet à l'huile chaude 100% bio pour vous recentrer et libérer les tensions accumulées.",
    details: [
      "Massage du haut-du corps relaxant et réconfortant",
      "Utilisation de la vibration pour lever les blocages et relancer l'énergie vitale",
      "Enveloppement aux tissus Rebozos",
      "Soutien à la récupération physique et émotionnelle",
    ],
    pricing: [{ label: "Séance (1h15)", price: "70 €" }],
  },
  {
    id: "massage-meridiens-cycles",
    title: "Massage \"Méridiens et cycles\"",
    kicker: "Massage Femme · Cycle & Équilibre hormonal",
    duration: "1h15",
    summary:
      "Massage complet du corps : jambes, dos et bras.\n\nDans un premier temps, le massage permet de détendre les différentes couches musculaires et de drainer votre corps. Puis, j'utilise l'acupression en stimulant les méridiens spécifiques au cycle hormonal.\n\nCe soin s'adresse aux femmes ayant vécu une IMG, une IVG ou un arrêt naturel de grossesse ainsi qu'aux personnes en ménopause ou atteintes d'adénomyose, d'endométriose, de fibrome, de SOPK, de SPM et de règles douloureuses.",
    details: [
      "Massage complet du corps, énergisant et rééquilibrant",
      "Utilisation de la vibration pour lever les blocages énergétiques et relancer l'énergie vitale grâce au bol tibétain et au diapason",
      "Aide à rééquilibrer le cycle féminin",
      "Enveloppement aux tissus Rebozos",
      "Soutien à la récupération physique et émotionnelle",
    ],
    note: "Soin bien-être, équilibrant, non médical, sans obligation de résultat.",
    pricing: [{ label: "Séance (1h15)", price: "70 €" }],
  },
]

export const prestationsBebe = [
  {
    id: "atelier-massage-bebe",
    title: "Atelier Massage Bébé",
    image: images.massageBebe,
    duration: "1h00",
    summary: "Apprenez les gestes du massage bébé pour apaiser, soulager les petits maux et renforcer votre lien par le toucher.",
    pricing: [
      { label: "Individuel", price: "50 €" },
      { label: "Collectif", price: "20 €" },
    ],
  },
  {
    id: "atelier-portage",
    title: "Atelier Portage",
    image: images.portageBebe,
    duration: "1h00",
    summary:
      "Le portage est une belle façon de répondre aux besoins de proximité de bébé tout en favorisant le lien d'attachement.\n\nCet atelier vous permettra de découvrir les bienfaits du portage, les différentes solutions existantes et les règles essentielles pour porter bébé en toute sécurité.\n\nUn temps d'échange et de pratique pour vous familiariser avec le portage et gagner en confiance avant ou après l'arrivée de bébé.\n\nUn atelier conseillé dès la grossesse pour préparer sereinement vos premiers moments de portage !",
    details: [
      "Atelier collectif autour du portage bébé",
      "Découvrir les bienfaits du portage et le lien d'attachement",
      "Explorer les différentes solutions de portage existantes",
      "Apprendre les règles essentielles pour porter bébé en toute sécurité",
      "Un temps d'échange et de pratique, avant ou après l'arrivée de bébé",
    ],
    pricing: [
      { label: "Individuel", price: "50 €" },
      { label: "Collectif", price: "20 €" },
    ],
  },
  {
    id: "atelier-baby-yoga",
    title: "Atelier Baby Yoga",
    image: images.babyYoga,
    duration: "1h00",
    summary: "Des mouvements doux et ludiques pour accompagner l'éveil moteur de bébé et partager un moment de complicité.",
    pricing: [
      { label: "Individuel", price: "50 €" },
      { label: "Collectif", price: "20 €" },
    ],
  },
  {
    id: "reflexologie-bebe",
    title: "Atelier réflexologie émotionnelle",
    image: images.reflexologieBebe,
    duration: "1h00",
    summary:
      "Chaque séance comprend un temps d'échange pour faire connaissance afin d'adapter le soin aux besoins de votre enfant.",
    details: [
      "Pour quoi ?",
      "colique, constipation",
      "reflux gastrique",
      "douleurs dentaire",
      "angoisse de séparation",
      "trouble du sommeil",
      "pleurs du soir",
      "excitabilité",
    ],
    note: "Accompagnement bien-être, équilibrant, non médical, sans obligation de résultat.",
    pricing: [
      { label: "Individuel", price: "50 €" },
      { label: "Collectif", price: "20 €" },
    ],
  },
]

export const testimonials = [
  {
    quote: "Les mots sont difficiles à trouver pour parler du moment que Maïwenn m’a fait passé. Elle a adoucit par son massage post natale, les souvenirs que j’avais de mon accouchement, un moment pour moi que je n’oublierai jamais. J’ai hâte de lui confier mon bébé. Une super idée cadeaux pour les jeunes mamans et leurs bébés !",
    name: "Bérengère",
    detail: "Massage post-natal",
  },
  {
    quote: "Un grand merci à toi pour la séance de réflexologie avec mes enfants. Tu as su les mettre en confiance et les accompagner avec beaucoup de douceur, de bienveillance et de professionnalisme. Ils se sont sentis très à l’aise et ont vraiment apprécié ce joli moment de détente. Je recommande les yeux fermés tes séances. Maïwenn est une personne adorable qui exerce avec passion ❤️ Merci encore pour ce doux moment ! 🌸✨",
    name: "Maëva",
    detail: "Séance de réflexologie pour ses enfants",
  },
  {
    quote: "Léon a eu la chance de passer entre les mains de Maïwenn pour une séance de réflexologie. Maïwenn est douce, passionnée, et à l’écoute, c’était un réel plaisir de passer ce moment ensemble.",
    name: "Marianne",
    detail: "Séance de réflexologie avec Léon",
  },
  {
    quote: "Maiwenn a réalisé une séance de réflexologie plantaire sur mon fils de deux ans, j’ai vraiment apprécié son approche en douceur et sa bienveillance ! Il a été tellement détendu qu’il m’a fait une bonne sieste juste après.",
    name: "Coralie",
    detail: "Réflexologie plantaire (2 ans)",
  },
  {
    quote: "J’ai rencontré Maiwenn pour un massage « méridiens et cycles » pour des menstruations douloureuses, je peux dire que les résultats sont plutôt bluffant dès la deuxième rencontre. Le diapason a été une belle découverte pour moi, avec de nouvelles sensations. J’ai particulièrement aimé l’enveloppement, qui m’a offert un moment de réconfort et de sérénités. Maiwenn se distingue par sa douceur, son écoute et sa bienveillance. Elle instaure naturellement un climat de confiance qui permet de lâcher prise pleinement. Une très belle expérience que je recommande sans hésitation et que j’ai hâte de renouveler. Merci beaucoup Maiwenn 🌸",
    name: "Bleuenn",
    detail: "Massage Méridiens et Cycles",
  },
  {
    quote: "Maïwenn m'a reçu pour le massage \"Méridiens et cycles\". Actuellement en ménopause avec les effets secondaires, je ressens déjà les effets sur mon corps. Après 2 séances, j'ai moins de bouffées de chaleur et un meilleur sommeil. Durant les massages, j'ai ressenti beaucoup de respect et de douceur. J'ai réussi à lâcher prise et à me laisser aller grâce à l'utilisation du bol tibétain et du diapason. La séance s'est terminée par un enveloppement du corps avec les tissus rebozos qui m'ont aidé à me reconnecter à mon corps. Merci pour tout",
    name: "Enora",
    detail: "Massage Méridiens et Cycles",
  },
  {
    quote: "J’ai eu la chance d’être accompagnée par Maïwenn pendant mon post-partum et je ne peux que la recommander. Son écoute, sa bienveillance et son soutien ont fait toute la différence pour moi. Elle a su m’apporter sérénité et confiance à chaque étape. Un accompagnement précieux et humain, merci infiniment !",
    name: "Joanna",
    detail: "Accompagnement post-partum",
  },
  {
    quote: "J’ai eu la chance de partager ce moment avec Maïwenn et ma fille. Elle a été très douce, attentionnée, bienveillante et vraiment à l’écoute de ma fille et de ses besoins. J’ai également beaucoup apprécié son écoute envers moi, notamment au regard de mon post-partum qui a été un peu compliqué. Sa douceur et sa bienveillance m’ont vraiment fait du bien. Une très belle expérience avec une personne qui met tout de suite en confiance. Je recommande +++++ ! 🌸",
    name: "Marjolaine",
    detail: "Séance maman & bébé",
  },
  {
    quote: "Les visites post-partum m'ont sauvée. J'ai pu me reposer, poser mes doutes, et me sentir mère sans me juger.",
    name: "Inès",
    detail: "Accompagnement du quatrième trimestre",
  },
  {
    quote: "Enfin quelqu'un qui ne nous disait pas quoi faire, mais qui nous aidait à écouter ce dont nous avions besoin.",
    name: "Camille",
    detail: "Préparation à la naissance",
  },
]

export const faqDoula = [
  {
    question: "Qu'est-ce qu'une doula / accompagnante périnatale ?",
    answer:
      "Une doula est une professionnelle de l'accompagnement non médical à la naissance et à la parentalité. Elle offre un soutien émotionnel, physique, informatif et logistique aux futurs et jeunes parents, de la pré-conception au post-partum.",
  },
  {
    question: "Quelle est la différence entre une doula et une sage-femme ?",
    answer:
      "La sage-femme assure le suivi médical de la grossesse, de l'accouchement et de la santé de la maman et du bébé. L'accompagnement d'une doula est exclusivement non médical et intervient en complémentarité pour vous écouter, vous informer, vous masser et soutenir votre cheminement sans aucun geste médical.",
  },
  {
    question: "À quel moment de la grossesse puis-je faire appel à vous ?",
    answer:
      "Vous pouvez me contacter dès votre désir d'enfant, au tout début de votre grossesse, au cours des 2e et 3e trimestres, ou même après la naissance pour un soutien lors du post-partum.",
  },
  {
    question: "Mon partenaire / co-parent a-t-il sa place lors des séances ?",
    answer:
      "Absolument ! Le co-parent est le bienvenu à chaque étape. Je propose notamment la séance couple « Le temps de nous » pour vous donner des clés concrètes (postures, bercements, soutien émotionnel) et renforcer votre complicité.",
  },
  {
    question: "Où se déroulent les rendez-vous et séances de massage ?",
    answer:
      "Je vous reçois avec plaisir dans mon espace dédié au 19 rue Louis Le Moenic, 56240 Inguiniel, ou me déplace directement à votre domicile dans un rayon de 35 km (au-delà de 15 km, des frais de 0,40 €/km s'appliquent). Des séances d'écoute en visio sont également disponibles.",
  },
  {
    question: "Comment réserver une séance ou un accompagnement ?",
    answer:
      "Vous pouvez réserver directement un créneau en ligne via le lien Calendly ou m'envoyer un message via la page Contact pour que nous discutions de vos besoins.",
  },
]
